import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { TrainersLabelPipe } from '../../trainers-label.pipe';
import { FormatDatePipe } from '../../format-date.pipe';
import { LabelSkillComponent } from '../../label/label.component';

@Component({
    selector: 'staffing-results',
    templateUrl: 'staffing-result.component.html',
    styleUrls: [
        'staffing-result.component.scss',
        '../../label/label.component.scss',
    ],
    providers: [
        TrainersLabelPipe,
        FormatDatePipe,
        LabelSkillComponent,
        TranslatePipe,
    ],
})
export class StaffingResultComponent implements OnInit {
    @Input() session: any;
    @Input() trainers: any[];
    @Input() responses: any[];
    @Input() sendMailFunction: any;

    ngOnInit(): void {}

    sendMail(trainerId): void {
        this.sendMailFunction(this.session.id, [trainerId]).subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/result/staffing-result.component.ts